import "./index.scss";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import { THINKFIC_BASE_URL } from "../../../../apiConfigs/urlConfig";
import { getLatestProgress } from "../../../../store/features/UserDashboard/NewUserDashboard/NewUserDashoardApi";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import EmptyProgressCard from "./EmptyProgressCard";
import { loginToThinkificAndRedirect } from "../../../../store/features/Thinkific/ThikificApi";

import { hasAnyFreeRole, isSelfPacedRole } from "../../../../helpers/utils/roleUtils";

const ProgressSection = (props: any) => {
  const dispatch = useAppDispatch();
  const thinkificState: any = useAppSelector((store: RootStore) => {
    return store.ThinkificSlice;
  });
  const [slug, setSlug] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const dashState: any = useAppSelector((store: RootStore) => {
    return store.NewDashboard;
  });
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });
  const themeState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });

  useEffect(() => {
    dispatch(getLatestProgress());
  }, []);

  const startLearning = async (slug: string) => {
    setSlug(slug);
    setLoading(true);
    await dispatch(
      loginToThinkificAndRedirect({
        slug: slug,
      })
    ).then((res: any) => {
      if (res.payload) {
        console.log(res.payload.url);
        window.open(res.payload.url, "_blank");
      }
    });
    setLoading(false);
  };

  return (
    <>
      {" "}
      <div className="scroll__position__for__progress" id="myprogress" />
      <div className="new__progress__wrapper">
        <div className="center_wrapper padding__handle">
          <h1 className="title">  {(isSelfPacedRole(authState?.tac_user?.role,authState) ||  hasAnyFreeRole(authState?.tac_user?.all_roles)  ) ? "My Courses &  Progress"
                      :"My Progress"} </h1>
          <div className="progress__list__sections">
            {!dashState.loading.progress &&
              dashState.req_success.progress &&
              dashState.progress.map((data: any) => {
                return (
                  <div className="progress__card test" key={data.id}>
                    <div className="name__div">
                      <Link to={`/course-progress/${data.id}`}>
                        <h6 className="course__name">{data.name}</h6>
                      </Link>
                    </div>
                    <div className="progress_card_divider" />
                    <div className="row">
                      <div className="progress__div">
                        <div
                          className={`progress__bar  progress-${data.percentage_completed}`}
                        />
                        <span className="precentage">
                          {data.percentage_completed}%
                        </span>
                      </div>
                      {loading && slug === data.slug ? (
                        <div className="spinner mr-1" />
                      ) : (
                        <span
                          role="button"
                          aria-hidden
                          className={
                            data.percentage_completed === 100
                              ? "completed"
                              : "resume"
                          }
                          onClick={() => startLearning(data.slug)}
                          aria-disabled
                        >
                          {data.percentage_completed === 100
                            ? "Completed"
                            : "Resume"}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
          {dashState.loading.progress ||
            (dashState.progress.length === 0 && <EmptyProgressCard />)}
        </div>
      </div>
    </>
  );
};

export default ProgressSection;
